"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatBullets = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const formatBullets = bulletList => {
  if (bulletList && bulletList?.length) {
    return bulletList?.map((bullet, i) => {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: i,
        className: "trial-summary--bullets--point"
      }, bullet);
    });
  } else return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
exports.formatBullets = formatBullets;